class PriceToggle {
  constructor() {
    this.toggleElements = document.querySelectorAll(".toggle-checkbox");
    this.isTaxIncluded = this.getStoredState();

    this.init();
  }

  init() {
    this.updateToggleState();
    this.updateAllPrices();
    this.bindEvents();

    this.observeDOMChanges();
  }

  getStoredState() {
  const stored = localStorage.getItem("price-tax-included");
  return stored ? JSON.parse(stored) : false;
}
  

  setStoredState(state) {
    localStorage.setItem("price-tax-included", JSON.stringify(state));
  }

  updateToggleState() {
    this.toggleElements.forEach((toggle) => {
      toggle.checked = this.isTaxIncluded;
    });
  }

  updateAllPrices() {
    this.updateProductPrices();
    this.updateCartPrices();
    this.updateCollectionPrices();
    this.updateToggleLabels();
    this.updateTaxLabels();
  }

  updateProductPrices() {
  const singlePriceElements = document.querySelectorAll(
    "[data-price-incl-tax][data-price-excl-tax]:not([data-price-slot])"
  );

  singlePriceElements.forEach((element) => {
    if (this.isTaxIncluded) {
      element.textContent = element.dataset.priceInclTax || "";
      element.classList.add("price-incl-tax");
      element.classList.remove("price-excl-tax");
    } else {
      element.textContent = element.dataset.priceExclTax || "";
      element.classList.add("price-excl-tax");
      element.classList.remove("price-incl-tax");
    }
  });

  const dualBlocks = document.querySelectorAll(".price--dual-tax");

  dualBlocks.forEach((block) => {
    const primaryLabel = block.querySelector('[data-tax-label="primary"]');
    const secondaryLabel = block.querySelector('[data-tax-label="secondary"]');

    const primaryCurrent = block.querySelector('[data-price-slot="primary-current"]');
    const primaryCompare = block.querySelector('[data-price-slot="primary-compare"]');
    const secondaryCurrent = block.querySelector('[data-price-slot="secondary-current"]');
    const secondaryCompare = block.querySelector('[data-price-slot="secondary-compare"]');

    if (this.isTaxIncluded) {
      if (primaryLabel) primaryLabel.textContent = "Incl. btw:";
      if (secondaryLabel) secondaryLabel.textContent = "Excl. btw:";

      if (primaryCurrent) primaryCurrent.textContent = primaryCurrent.dataset.priceInclTax || "";
      if (primaryCompare) primaryCompare.textContent = primaryCompare.dataset.priceInclTax || "";

      if (secondaryCurrent) secondaryCurrent.textContent = secondaryCurrent.dataset.priceExclTax || "";
      if (secondaryCompare) secondaryCompare.textContent = secondaryCompare.dataset.priceExclTax || "";
    } else {
      if (primaryLabel) primaryLabel.textContent = "Excl. btw:";
      if (secondaryLabel) secondaryLabel.textContent = "Incl. btw:";

      if (primaryCurrent) primaryCurrent.textContent = primaryCurrent.dataset.priceExclTax || "";
      if (primaryCompare) primaryCompare.textContent = primaryCompare.dataset.priceExclTax || "";

      if (secondaryCurrent) secondaryCurrent.textContent = secondaryCurrent.dataset.priceInclTax || "";
      if (secondaryCompare) secondaryCompare.textContent = secondaryCompare.dataset.priceInclTax || "";
    }
  });
}

  updateCartPrices() {
  // Cart drawer en winkelwagen tonen altijd zowel ex. als incl. btw,
  // dus hier hoeft de toggle niets te doen.
}

  updateCollectionPrices() {
    const collectionPriceElements = document.querySelectorAll(
      ".product-card .price .amount"
    );

    collectionPriceElements.forEach((element) => {
      if (element.dataset.priceInclTax && element.dataset.priceExclTax) {
        if (this.isTaxIncluded) {
          element.textContent = element.dataset.priceInclTax;
          element.classList.add("price-incl-tax");
          element.classList.remove("price-excl-tax");
        } else {
          element.textContent = element.dataset.priceExclTax;
          element.classList.add("price-excl-tax");
          element.classList.remove("price-incl-tax");
        }
      }
    });
  }

  updateToggleLabels() {
    const labels = document.querySelectorAll(".toggle-label");
    labels.forEach((label) => {
      if (
        label.textContent.includes("Incl. btw") ||
        label.textContent.includes("Excl. btw")
      ) {
        label.textContent = this.isTaxIncluded ? "Incl. btw" : "Excl. btw";
      }
    });
  }

  updateTaxLabels() {
  const taxElements = document.querySelectorAll(".product__tax");
  taxElements.forEach((element) => {
    element.textContent = "Prijzen excl. en incl. 21% btw.";
  });
}

  bindEvents() {
    this.toggleElements.forEach((toggle) => {
      toggle.addEventListener("change", (e) => {
        this.isTaxIncluded = e.target.checked;
        this.setStoredState(this.isTaxIncluded);
        this.updateAllPrices();

        this.animatePriceChange();
      });
    });
  }

  animatePriceChange() {
    const priceElements = document.querySelectorAll(".price .amount");
    priceElements.forEach((element) => {
      element.style.transform = "scale(1.05)";
      setTimeout(() => {
        element.style.transform = "scale(1)";
      }, 200);
    });
  }

  observeDOMChanges() {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;

      mutations.forEach((mutation) => {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (
                node.querySelector &&
                node.querySelector(
                  "[data-price-incl-tax], [data-price-excl-tax]"
                )
              ) {
                shouldUpdate = true;
              }
            }
          });
        }
      });

      if (shouldUpdate) {
        setTimeout(() => {
          this.updateAllPrices();
        }, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  refreshPrices() {
    this.updateAllPrices();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.priceToggle = new PriceToggle();
});

window.PriceToggle = PriceToggle;
